import { render, staticRenderFns } from "./mbuild.vue?vue&type=template&id=55c74c5e&scoped=true"
import script from "./mbuild.vue?vue&type=script&lang=js"
export * from "./mbuild.vue?vue&type=script&lang=js"
import style0 from "./mbuild.vue?vue&type=style&index=0&id=55c74c5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c74c5e",
  null
  
)

export default component.exports